import FuseShortcuts from '@fuse/core/FuseShortcuts';
import { usePrevious } from '@fuse/hooks';
import React, { useMemo, useEffect, useState } from 'react';
import _ from 'lodash';
import { User } from '@auth/user';
import useUser from '@auth/useUser';
import setIn from '@/utils/setIn';
import useNavigation from './hooks/useNavigation';

type NavigationShortcutsProps = {
  className?: string;
  variant?: 'horizontal' | 'vertical';
};

/**
 * The navigation shortcuts.
 */
function NavigationShortcuts(props: NavigationShortcutsProps) {
  const { variant, className } = props;
  const { flattenNavigation: navigation } = useNavigation();
  const { data: user, updateUser, isGuest } = useUser();

  // Ensure `shortcuts` is parsed into an array
  const initialShortcuts = useMemo(() => {
    try {
      return Array.isArray(user?.shortcuts) ? user.shortcuts : JSON.parse(user?.shortcuts || '[]');
    } catch {
      console.error('Failed to parse shortcuts, defaulting to an empty array');
      return [];
    }
  }, [user?.shortcuts]);

  const [userShortcuts, setUserShortcuts] = useState<string[]>(initialShortcuts);
  const prevUserShortcuts = usePrevious(userShortcuts);

  useEffect(() => {
    if (!isGuest && prevUserShortcuts && !_.isEqual(userShortcuts, prevUserShortcuts)) {
      updateUser(setIn(user, 'shortcuts', JSON.stringify(userShortcuts)) as User);
    }
  }, [isGuest, userShortcuts]);

  function handleShortcutsChange(newShortcuts: string[]) {
    setUserShortcuts(newShortcuts);
  }

  return (
    <FuseShortcuts
      className={className}
      variant={variant}
      navigation={navigation}
      shortcuts={userShortcuts}
      onChange={handleShortcutsChange}
    />
  );
}

export default NavigationShortcuts;
